<template>
    <div>
        <SearchTabs />
    </div>
</template>
<script>
import SearchTabs from './component/SearchTabs'

export default {
    name: "searchManagement",
    components: {
        SearchTabs,
    }
}
</script>


// WEBPACK FOOTER //
// src/views/site/search/SearchManagement.vue